<template>
  <div id="exchange-coupon">
    <el-dialog :title="'兑换优惠券'" v-model="showModal" custom-class="coupon-exchange-modal" @close="close">
      <div class="input-coupon">
        <input class="exchange-coupon-input" placeholder="输入优惠码" :value="couponCode" @input="changeCouponCode" :maxlength="10"/>
      </div>
      <div class="bottom-btns">
        <el-button type="default" class="cancel-button" @click="close">取消</el-button>
        <el-button type="primary" class="exchange-button" :disabled="couponCode.length < 6" @click="exchange">兑换</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import couponService from '../../../services/coupon-service';
import utils from '../../../libs/utils';

export default {
  name: 'exchange-coupon',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 订单号
    orderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showModal: this.value, // 是否展示
      couponCode: '',
    };
  },
  methods: {
    // 关闭
    close() {
      this.$emit('input', false);
    },

    // 修改优惠券码
    changeCouponCode(event) {
      this.couponCode = couponService.getValue(event);
      this.$forceUpdate();
    },

    // 兑换
    exchange() {
      couponService.orderCouponExchange({
        code: this.couponCode,
        order_id: this.orderId,
      }).then(() => {
        this.$emit('addedCoupon');
        this.close();
        utils.msg.success('兑换成功!');
      }).catch((err) => {
        if (err.ret === -2) {
          utils.msg.error('所兑换优惠券不适用当前订单，已存入账户优惠券');
          this.close();
        } else {
          utils.msg.error(err.msg);
        }
      });
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (this.showModal) {
        this.couponCode = '';
      }
    },
  },
};
</script>

<style lang="less">
#exchange-coupon {
  .coupon-exchange-modal {
    width: 500px;
    top: 50% !important;
    transform: translate(-50%, -50%);
    .el-dialog__header {
      padding: 20px;
      border-bottom: 1px solid #f0f0f0;
      text-align: center;
      .el-dialog__title {
        font-size: 18px;
        color: #333;
        font-weight: normal;
      }
    }
    .el-dialog__body {
      padding: 40px;
      .input-coupon {
        width: 420px;
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #aaa;
        margin-right: 30px;
        border-radius: 4px;
        border: solid 1px #ddd;
        margin-right: 10px;
        ::-webkit-input-placeholder { /* WebKit browsers */
          color:#aaa;
        }
        :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
          color:#aaa;
        }
        ::-moz-placeholder { /* Mozilla Firefox 19+ */
          color:#aaa;
        }
        :-ms-input-placeholder { /* Internet Explorer 10+ */
          color:#aaa;
        }
        input.exchange-coupon-input {
          border: none;
          flex: 1;
          color: #333;
          appearance: none;
          background-color: #fff;
          background-image: none;
          border-radius: 4px;
          box-sizing: border-box;
          color: #1f2d3d;
          display: inline-block;
          font-size: inherit;
          height: 36px;
          line-height: 1;
          outline: none;
          padding: 3px 10px;
          transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        }
      }
      .bottom-btns {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        button {
          width: 200px;
          height: 40px;
        }
        .cancel-button {
          border: 1px solid #e3e3e3;
          color: #777;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/exchange-coupon.vue